import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Target } from "lucide-react";

// Inline per-symbol verified win-rate badge — shown in the Trade Setup
// header for Pro/Admin. Surfaces T1 vs T2 separately so users can read
// the quality of the historical edge at a glance.
export default function SymbolAccuracyBadge({ symbol, mode }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!symbol) return;
    let cancel = false;
    (async () => {
      try {
        const { data } = await api.get(`/accuracy/symbol/${encodeURIComponent(symbol)}`, { params: { mode } });
        if (!cancel) setStats(data);
      } catch {
        if (!cancel) setStats(null);
      }
    })();
    return () => { cancel = true; };
  }, [symbol, mode]);

  if (!stats) return null;
  const total = stats.total_closed || 0;
  if (total < 5) {
    return (
      <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-600" data-testid="symbol-accuracy-building">
        <Target className="inline h-3 w-3 mr-1" /> building history · {total} closed
      </div>
    );
  }
  const wr = stats.win_rate;
  const color = wr >= 65 ? "text-[#22C55E] border-[#22C55E]/40" : wr >= 50 ? "text-[#F59E0B] border-[#F59E0B]/40" : "text-[#EF4444] border-[#EF4444]/40";
  return (
    <div className={`inline-flex items-center gap-2 px-2 py-0.5 border text-[10px] font-mono uppercase tracking-widest ${color}`} data-testid="symbol-accuracy-badge" title={`${stats.hit_t2} hit T2 · ${stats.hit_t1} hit T1 only · ${stats.losses} hit SL`}>
      <span className="inline-flex items-center gap-1"><Target className="h-3 w-3" /> {wr}%</span>
      <span className="text-zinc-600">·</span>
      <span className="text-[#22C55E]" data-testid="symbol-accuracy-t2">T2 {stats.full_target_rate}%</span>
      <span className="text-zinc-700">·</span>
      <span className="text-[#16A34A]/80" data-testid="symbol-accuracy-t1">T1 {stats.t1_only_rate}%</span>
      <span className="text-zinc-700">·</span>
      <span className="text-zinc-500">{total}</span>
    </div>
  );
}
